const $ = jQuery;

export default class FormHandler {
    constructor() {
        $('.form').attr('novalidate', 'novalidate');
        $('body').on('submit', '.form', (e) =>  {
            e.preventDefault();
            let form = e.currentTarget,
                errors = this._validate(form);
            if (errors.length > 0) {
                this.onError(form, errors);
                return false;
            }
            let data = new FormData(form);
            $.ajax({
                url: window.location.href,
                data: data,
                processData: false,
                contentType: false,
                type: 'POST',
                success: (data) => {
                    console.log(data);
                    this.onSuccess(form);
                },
                fail: () => this.onError(form)
            });
            return false;
        }).on('click', '.form--success', (e) => {
            $(e.currentTarget).removeClass('form--success');
        });
    }
    _validate(context) {
        const errors = [];
        $(context).removeClass('form--has-errors form--success').find('.form__field--error').removeClass('form__field--error');
        $(context).find('.form__field').each((i, field)=>  {
            let $field = $(field),
                node = field.firstElementChild;
            if (false === this._isNotEmpty($field, node)) {
                $field.addClass('form__field--error');
                errors.push($field.attr('data-error'));
            }
        });
        return errors;
    }
    _isNotEmpty($field, node) {
        if ($field.hasClass('form__field--email')) {
            return this._isEmail(node);
        }
        if (false == $(node).prop('required')) {
            return true;
        }
        if ($field.hasClass('form__field--checkbox')) {
            return $(node).is(':checked');
        }
        if ($field.hasClass('form__field--radio')) {
            return $(node).closest('.form').find(`[name="${$(node).attr('name')}"]:checked`).length > 0;
        }
        return $(node).val() !== '';
    }
    _isEmail(node) {
        let value = $(node).val();
        if (value === '') {
            return false;
        }
        const email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return email.test(value);
    }
    onError(context, errors = []) {
        $(context).addClass('form--has-errors');
        let $errorNode = $(context).find('.form__errors');
        if ($errorNode.length == 0) {
            $errorNode = $('<div class="form__errors" />')
            $errorNode.insertBefore($(context).find('.form__action--submit'));
        }
        $errorNode.empty();
        if (errors.length == 0) {
            $errorNode.append(`<p>${$(context).attr('data-error')}</p>`);
        } else {
            $.each(errors, (i, error) => {
                $errorNode.append(`<p>${error}</p>`);
            });
        }
    }
    onSuccess(context) {
        let $successNode = $(context).find('.form__message');
        if ($successNode.length == 0) {
            $successNode = $('<div class="form__message" />')
            $successNode.appendTo($(context));
        }
        setTimeout(() => {
            $successNode.empty().append(`<p>${$(context).attr('data-success')}</p>`);
            $(context).addClass('form--success');
        },0);
        setTimeout(() => {
            $(context).removeClass('form--success');
        }, 4000);
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/modules/FormHandler.js